module.exports = __webpack_public_path__ + "dc5e8181ef5a0d109542e68afe0c95b0.ttf";